// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { ActiveState } from "./active-state";
import { SequenceStepKind } from "./sequence-step-kind";
import { SequenceStepScope } from "./sequence-step-scope";
import { StepPositionSource } from "./step-position-source";
import { Uuid, UuidT, verifyUuid } from "../front-end/uuid";

/**
 * Added v5 — one ordered step in a modifier's expected-message sequence.
 *
 * After the modifier's `payload` is written to the target channel, VTS waits
 * for these steps, in order, on the modifier's observe channel
 * (`ChannelModifier.observe_channel_id`, v7; the target channel when absent).
 * A step is satisfied by a CHANGE in the observed message's state that VTS
 * received at or after the payload write began, never by a level left over
 * from earlier. For BEFORE modifiers the sequence gates the held source
 * message; for INBOUND AFTER modifiers it is observed for logging only.
 *
 * The expected message is stored as the same (content, value) scalar pair
 * the v4 source leaf and the adapter `Key` table use — NOT an `Ln2.Message`
 * union. Unions drop their discriminant on the Go Object-API round-trip
 * (the v4 lesson); scalars are round-trip-safe across Rust/Go/TS.
 */
export class ModifierSequenceStep implements flatbuffers.IUnpackableObject<ModifierSequenceStepT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): ModifierSequenceStep {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsModifierSequenceStep(
    bb: flatbuffers.ByteBuffer,
    obj?: ModifierSequenceStep,
  ): ModifierSequenceStep {
    return (obj || new ModifierSequenceStep()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsModifierSequenceStep(
    bb: flatbuffers.ByteBuffer,
    obj?: ModifierSequenceStep,
  ): ModifierSequenceStep {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new ModifierSequenceStep()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  /**
   * `MessageContent` discriminant the step waits to observe on the target
   * channel (same discriminant space as `ChannelModifier.source_message_content`;
   * u8 range 0..=9 widened to short). 0 (`MessageContent::NONE`) is invalid
   * for a step and means "unset" — VTS drops a step with content 0.
   */
  expectedMessageContent(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readInt16(this.bb_pos + offset) : 0;
  }

  /**
   * The specific leaf value within that content the step waits to observe
   * (same value space as `ChannelModifier.source_message_value`).
   */
  expectedMessageValue(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  /**
   * Per-step receive timeout in milliseconds. If the expected message is
   * not observed within this budget the gate fails, and the modifier's
   * `timeout_policy` decides the held message's fate (RELEASE by default).
   * Default 2000 ms mirrors the legacy BEFORE ack timeout. Stored as uint
   * (non-negative milliseconds); 0 means "use the runtime default"
   * (VTS `DEFAULT_STEP_TIMEOUT_MS`).
   */
  timeoutMs(): number {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 2000;
  }

  /**
   * Added v7. The state the observed message must change TO: `ACTIVE`,
   * `INACTIVE`, or `UNSET` (the default) for either. A two-step sequence
   * INACTIVE then ACTIVE waits for a device to go busy and then finish, so
   * the previous action's completion cannot satisfy it.
   */
  expectedActive(): ActiveState {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : ActiveState.UNSET;
  }

  /**
   * Added v7. How the observed message's position (and lift) must agree with
   * the payload's. See `SequenceStepScope` in enums.fbs.
   */
  scope(): SequenceStepScope {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : SequenceStepScope.SAME_POSITION;
  }

  /**
   * Added v8. What this step does. `WAIT` (the default) is every pre-v8 step;
   * the other kinds ignore `expected_message_*`, `expected_active` and
   * `scope`. See `SequenceStepKind` in enums.fbs.
   */
  kind(): SequenceStepKind {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : SequenceStepKind.WAIT;
  }

  /**
   * Added v8. The channel a `WAIT` step observes. Absent: the modifier's
   * `observe_channel_id`, or its target. A step before `RELEASE` may not
   * observe the source channel (its loop is held while the gate waits); a
   * step after it may.
   */
  observeChannelId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  /**
   * Added v8. Which floor the `SAME_POSITION` scopes compare against, and
   * which floor a `SEND` step sends to. See `StepPositionSource`.
   */
  positionSource(): StepPositionSource {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : StepPositionSource.PAYLOAD;
  }

  /**
   * Added v8. A `WAIT` step passes at once when the observed channel already
   * reports the expected level (a car already standing at the floor) instead
   * of waiting for a change.
   */
  satisfiedIfCurrent(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  /**
   * Added v8. Runs even after an earlier step after `RELEASE` failed: cleanup
   * that must happen, such as locking a floor again.
   */
  alwaysRun(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  /**
   * Added v8. `SEND`: the channel to send to. Absent: the modifier's target.
   */
  targetChannelId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 24);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  /**
   * Added v8. `SEND`: the message to send, as the same (content, value)
   * scalar pair the expected message uses; a union would not survive the
   * `LiftCloud` JSON round trip of the sequence. VTS builds a `BitMask`
   * `Control` message at the floor `position_source` names. Only `Control`
   * content is valid.
   */
  sendMessageContent(): number {
    const offset = this.bb!.__offset(this.bb_pos, 26);
    return offset ? this.bb!.readInt16(this.bb_pos + offset) : 0;
  }

  sendMessageValue(): number {
    const offset = this.bb!.__offset(this.bb_pos, 28);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  /**
   * Added v8. `SEND`: the `active` flag stamped on the sent message. `UNSET`
   * sends `true`, as the modifier payload does.
   */
  payloadActive(): ActiveState {
    const offset = this.bb!.__offset(this.bb_pos, 30);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : ActiveState.UNSET;
  }

  /**
   * Added v8. Operator-facing name, shown for this step in the monitoring
   * sequence view.
   */
  label(): string | null;
  label(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  label(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 32);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  static startModifierSequenceStep(builder: flatbuffers.Builder) {
    builder.startObject(15);
  }

  static addExpectedMessageContent(builder: flatbuffers.Builder, expectedMessageContent: number) {
    builder.addFieldInt16(0, expectedMessageContent, 0);
  }

  static addExpectedMessageValue(builder: flatbuffers.Builder, expectedMessageValue: number) {
    builder.addFieldInt32(1, expectedMessageValue, 0);
  }

  static addTimeoutMs(builder: flatbuffers.Builder, timeoutMs: number) {
    builder.addFieldInt32(2, timeoutMs, 2000);
  }

  static addExpectedActive(builder: flatbuffers.Builder, expectedActive: ActiveState) {
    builder.addFieldInt8(3, expectedActive, ActiveState.UNSET);
  }

  static addScope(builder: flatbuffers.Builder, scope: SequenceStepScope) {
    builder.addFieldInt8(4, scope, SequenceStepScope.SAME_POSITION);
  }

  static addKind(builder: flatbuffers.Builder, kind: SequenceStepKind) {
    builder.addFieldInt8(5, kind, SequenceStepKind.WAIT);
  }

  static addObserveChannelId(
    builder: flatbuffers.Builder,
    observeChannelIdOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(6, observeChannelIdOffset, 0);
  }

  static addPositionSource(builder: flatbuffers.Builder, positionSource: StepPositionSource) {
    builder.addFieldInt8(7, positionSource, StepPositionSource.PAYLOAD);
  }

  static addSatisfiedIfCurrent(builder: flatbuffers.Builder, satisfiedIfCurrent: boolean) {
    builder.addFieldInt8(8, +satisfiedIfCurrent, +false);
  }

  static addAlwaysRun(builder: flatbuffers.Builder, alwaysRun: boolean) {
    builder.addFieldInt8(9, +alwaysRun, +false);
  }

  static addTargetChannelId(
    builder: flatbuffers.Builder,
    targetChannelIdOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(10, targetChannelIdOffset, 0);
  }

  static addSendMessageContent(builder: flatbuffers.Builder, sendMessageContent: number) {
    builder.addFieldInt16(11, sendMessageContent, 0);
  }

  static addSendMessageValue(builder: flatbuffers.Builder, sendMessageValue: number) {
    builder.addFieldInt32(12, sendMessageValue, 0);
  }

  static addPayloadActive(builder: flatbuffers.Builder, payloadActive: ActiveState) {
    builder.addFieldInt8(13, payloadActive, ActiveState.UNSET);
  }

  static addLabel(builder: flatbuffers.Builder, labelOffset: flatbuffers.Offset) {
    builder.addFieldOffset(14, labelOffset, 0);
  }

  static endModifierSequenceStep(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  unpack(): ModifierSequenceStepT {
    return new ModifierSequenceStepT(
      this.expectedMessageContent(),
      this.expectedMessageValue(),
      this.timeoutMs(),
      this.expectedActive(),
      this.scope(),
      this.kind(),
      this.observeChannelId() !== null ? this.observeChannelId()!.unpack() : null,
      this.positionSource(),
      this.satisfiedIfCurrent(),
      this.alwaysRun(),
      this.targetChannelId() !== null ? this.targetChannelId()!.unpack() : null,
      this.sendMessageContent(),
      this.sendMessageValue(),
      this.payloadActive(),
      this.label(),
    );
  }

  unpackTo(_o: ModifierSequenceStepT): void {
    _o.expectedMessageContent = this.expectedMessageContent();
    _o.expectedMessageValue = this.expectedMessageValue();
    _o.timeoutMs = this.timeoutMs();
    _o.expectedActive = this.expectedActive();
    _o.scope = this.scope();
    _o.kind = this.kind();
    _o.observeChannelId =
      this.observeChannelId() !== null ? this.observeChannelId()!.unpack() : null;
    _o.positionSource = this.positionSource();
    _o.satisfiedIfCurrent = this.satisfiedIfCurrent();
    _o.alwaysRun = this.alwaysRun();
    _o.targetChannelId = this.targetChannelId() !== null ? this.targetChannelId()!.unpack() : null;
    _o.sendMessageContent = this.sendMessageContent();
    _o.sendMessageValue = this.sendMessageValue();
    _o.payloadActive = this.payloadActive();
    _o.label = this.label();
  }

  unpackFields(...fields: string[]): ModifierSequenceStepT {
    const t = new ModifierSequenceStepT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("expected_message_content")) {
      t.expectedMessageContent = this.expectedMessageContent();
    }
    if (fieldSet.has("expected_message_value")) {
      t.expectedMessageValue = this.expectedMessageValue();
    }
    if (fieldSet.has("timeout_ms")) {
      t.timeoutMs = this.timeoutMs();
    }
    if (fieldSet.has("expected_active")) {
      t.expectedActive = this.expectedActive();
    }
    if (fieldSet.has("scope")) {
      t.scope = this.scope();
    }
    if (fieldSet.has("kind")) {
      t.kind = this.kind();
    }
    if (fieldSet.has("observe_channel_id")) {
      t.observeChannelId =
        this.observeChannelId() !== null ? this.observeChannelId()!.unpack() : null;
    }
    if (fieldSet.has("position_source")) {
      t.positionSource = this.positionSource();
    }
    if (fieldSet.has("satisfied_if_current")) {
      t.satisfiedIfCurrent = this.satisfiedIfCurrent();
    }
    if (fieldSet.has("always_run")) {
      t.alwaysRun = this.alwaysRun();
    }
    if (fieldSet.has("target_channel_id")) {
      t.targetChannelId = this.targetChannelId() !== null ? this.targetChannelId()!.unpack() : null;
    }
    if (fieldSet.has("send_message_content")) {
      t.sendMessageContent = this.sendMessageContent();
    }
    if (fieldSet.has("send_message_value")) {
      t.sendMessageValue = this.sendMessageValue();
    }
    if (fieldSet.has("payload_active")) {
      t.payloadActive = this.payloadActive();
    }
    if (fieldSet.has("label")) {
      t.label = this.label();
    }
    return t;
  }
}

export class ModifierSequenceStepT implements flatbuffers.IGeneratedObject {
  constructor(
    public expectedMessageContent: number = 0,
    public expectedMessageValue: number = 0,
    public timeoutMs: number = 2000,
    public expectedActive: ActiveState = ActiveState.UNSET,
    public scope: SequenceStepScope = SequenceStepScope.SAME_POSITION,
    public kind: SequenceStepKind = SequenceStepKind.WAIT,
    public observeChannelId: UuidT | null = null,
    public positionSource: StepPositionSource = StepPositionSource.PAYLOAD,
    public satisfiedIfCurrent: boolean = false,
    public alwaysRun: boolean = false,
    public targetChannelId: UuidT | null = null,
    public sendMessageContent: number = 0,
    public sendMessageValue: number = 0,
    public payloadActive: ActiveState = ActiveState.UNSET,
    public label: string | Uint8Array | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    const observeChannelId =
      this.observeChannelId !== null ? this.observeChannelId!.pack(builder) : 0;
    const targetChannelId = this.targetChannelId !== null ? this.targetChannelId!.pack(builder) : 0;
    const label = this.label !== null ? builder.createString(this.label!) : 0;

    ModifierSequenceStep.startModifierSequenceStep(builder);
    ModifierSequenceStep.addExpectedMessageContent(builder, this.expectedMessageContent);
    ModifierSequenceStep.addExpectedMessageValue(builder, this.expectedMessageValue);
    ModifierSequenceStep.addTimeoutMs(builder, this.timeoutMs);
    ModifierSequenceStep.addExpectedActive(builder, this.expectedActive);
    ModifierSequenceStep.addScope(builder, this.scope);
    ModifierSequenceStep.addKind(builder, this.kind);
    ModifierSequenceStep.addObserveChannelId(builder, observeChannelId);
    ModifierSequenceStep.addPositionSource(builder, this.positionSource);
    ModifierSequenceStep.addSatisfiedIfCurrent(builder, this.satisfiedIfCurrent);
    ModifierSequenceStep.addAlwaysRun(builder, this.alwaysRun);
    ModifierSequenceStep.addTargetChannelId(builder, targetChannelId);
    ModifierSequenceStep.addSendMessageContent(builder, this.sendMessageContent);
    ModifierSequenceStep.addSendMessageValue(builder, this.sendMessageValue);
    ModifierSequenceStep.addPayloadActive(builder, this.payloadActive);
    ModifierSequenceStep.addLabel(builder, label);

    return ModifierSequenceStep.endModifierSequenceStep(builder);
  }

  clone(): ModifierSequenceStepT {
    const obj = new ModifierSequenceStepT();
    obj.expectedMessageContent = this.expectedMessageContent;
    obj.expectedMessageValue = this.expectedMessageValue;
    obj.timeoutMs = this.timeoutMs;
    obj.expectedActive = this.expectedActive;
    obj.scope = this.scope;
    obj.kind = this.kind;
    obj.observeChannelId = this.observeChannelId !== null ? this.observeChannelId!.clone() : null;
    obj.positionSource = this.positionSource;
    obj.satisfiedIfCurrent = this.satisfiedIfCurrent;
    obj.alwaysRun = this.alwaysRun;
    obj.targetChannelId = this.targetChannelId !== null ? this.targetChannelId!.clone() : null;
    obj.sendMessageContent = this.sendMessageContent;
    obj.sendMessageValue = this.sendMessageValue;
    obj.payloadActive = this.payloadActive;
    obj.label = this.label;
    return obj;
  }

  equals(other: ModifierSequenceStepT): boolean {
    if (this.expectedMessageContent !== other.expectedMessageContent) return false;
    if (this.expectedMessageValue !== other.expectedMessageValue) return false;
    if (this.timeoutMs !== other.timeoutMs) return false;
    if (this.expectedActive !== other.expectedActive) return false;
    if (this.scope !== other.scope) return false;
    if (this.kind !== other.kind) return false;
    if (this.observeChannelId !== null && other.observeChannelId !== null) {
      if (!this.observeChannelId!.equals(other.observeChannelId!)) return false;
    } else if (this.observeChannelId !== other.observeChannelId) return false;
    if (this.positionSource !== other.positionSource) return false;
    if (this.satisfiedIfCurrent !== other.satisfiedIfCurrent) return false;
    if (this.alwaysRun !== other.alwaysRun) return false;
    if (this.targetChannelId !== null && other.targetChannelId !== null) {
      if (!this.targetChannelId!.equals(other.targetChannelId!)) return false;
    } else if (this.targetChannelId !== other.targetChannelId) return false;
    if (this.sendMessageContent !== other.sendMessageContent) return false;
    if (this.sendMessageValue !== other.sendMessageValue) return false;
    if (this.payloadActive !== other.payloadActive) return false;
    if (this.label !== other.label) return false;
    return true;
  }
}

export function verifyModifierSequenceStep(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 2);
    verifier.checkScalarField(tablePos, 6, 4);
    verifier.checkScalarField(tablePos, 8, 4);
    verifier.checkScalarField(tablePos, 10, 1);
    verifier.checkScalarField(tablePos, 12, 1);
    verifier.checkScalarField(tablePos, 14, 1);
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 16);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkScalarField(tablePos, 18, 1);
    verifier.checkScalarField(tablePos, 20, 1);
    verifier.checkScalarField(tablePos, 22, 1);
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 24);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkScalarField(tablePos, 26, 2);
    verifier.checkScalarField(tablePos, 28, 4);
    verifier.checkScalarField(tablePos, 30, 1);
    {
      const pos = verifier.checkOffsetField(tablePos, 32);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
